import styled from 'styled-components';

export const PIDFullscreenEditorContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .diagram-cover {
    height: 100%;
    transition: 0.2s ease-in;
    position: relative;
    display: flex;

    .diagram-container {
      width: 100%;
      height: 90%;
      min-height: 90%;

      > svg {
        overflow: visible;
      }
    }
  }

  .open-drawer-button {
    inset-inline-end: 0;
    inset-block-end: 650px;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px 0 0
      ${({ theme: { token } }) => token.borderRadiusLG}px;
  }
`;
